import React from 'react';
import {
    PLAN_DETAIL_TAB,
    RESOURCE_APPLICATION_TAB, RESOURCE_ENVIRONMENT_TAB,
    RESOURCE_MODULE_TAB, RESOURCE_SKILL_SCHOOL_TAB,
    RESOURCE_SKILL_STREAM_TAB,
    VALIDITY_TAB
} from '../../../Constant/constant';
import PlanDetails from '../../../components/Management/PlanDetails';
import ValiditySection from '../../../components/Validity/ValiditySection';
import SelectResource from './SelectResource';


const ResourceSection = ({ activeTab , error}) => {

    const renderContent = () => {
        switch (activeTab) {
            case RESOURCE_APPLICATION_TAB:
            case RESOURCE_MODULE_TAB:
            case RESOURCE_ENVIRONMENT_TAB:
            case RESOURCE_SKILL_STREAM_TAB:
            case RESOURCE_SKILL_SCHOOL_TAB:
                return <SelectResource activeTab={activeTab} />
            case VALIDITY_TAB:
                return <ValiditySection heading="validity" />;
            case PLAN_DETAIL_TAB:
                return <PlanDetails heading="Plan Detail" />;
            default:
                return <></>;
        }
    };

    return (
        <>    
        <p>{error}</p>
        {renderContent()}
        </>
    );

}

export default ResourceSection